<script lang="ts">
  import { mailtoLink } from '../lib/config';

  const year = new Date().getFullYear();
</script>

<footer class="footer">
  <div class="inner">
    <span>gostword, {year}</span>
    <span aria-hidden="true">·</span>
    <a href={mailtoLink('gostword: обратная связь', '')}>Обратная связь</a>
  </div>
</footer>

<style>
  .footer {
    margin-top: 72px;
    border-top: 1px solid var(--border);
  }

  .inner {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 8px;
    max-width: 1240px;
    margin: 0 auto;
    padding: 22px 24px 28px;
    color: var(--text-3);
    font-size: 13px;
    text-align: center;
  }

  a {
    color: inherit;
  }

  a:hover {
    color: var(--text-2);
  }
</style>
